import { render, staticRenderFns } from "./SplitLayout.vue?vue&type=template&id=35e033f5&scoped=true"
import script from "./SplitLayout.vue?vue&type=script&lang=js"
export * from "./SplitLayout.vue?vue&type=script&lang=js"
import style0 from "./SplitLayout.vue?vue&type=style&index=0&id=35e033f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e033f5",
  null
  
)

export default component.exports